var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresenceAvailableMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.36,16.81c-2.71,0-4.91-2.5-4.91-5.51A5,5,0,0,1,14.24,6h.15a5,5,0,0,1,4.85,5.17h0v.13C19.24,14.36,17.07,16.81,14.36,16.81Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.85,16V26H26.5V16Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.74,18.32a5.57,5.57,0,0,0-.92.83,3.82,3.82,0,0,1-2.45.83h-.76a3.9,3.9,0,0,1-2.5-.83,6,6,0,0,0-1.18-1,2,2,0,0,0-2.37.39,18.49,18.49,0,0,0-2.5,3.8l-.35.88c-.16.36-.34,1-.09,1.33a2.08,2.08,0,0,0,1.51.53H18.76Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.96,
    y: 23.21,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.96,
    y: 21.55,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.62,
    y: 23.21,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.62,
    y: 21.55,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.28,
    y: 23.21,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.28,
    y: 21.55,
    width: 1.11,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.96,
    y: 17.13,
    width: 4.42,
    height: 3.32,
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAvailableMobile);
export default __webpack_public_path__ + "static/media/presence-available-mobile.5b27de95.svg";
export { ForwardRef as ReactComponent };